function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import CarouselTagsComponent from "../carousel-tags/carousel-tags-component";
import { StyledMobileCarouselTagsComponent } from "./mobile-carousel-tags-component.scss";
import MobileCard from "./mobile-cards/mobile-card";
const MobileCarouselTagsComponent = (props)=>{
    const itemRenderer = (card)=>/*#__PURE__*/ _jsx(MobileCard, _object_spread({}, card));
    const tagsCarouselProps = {
        itemRenderer,
        arrows: false,
        slidesToShow: 1.3,
        slidesToScroll: 1,
        waitForAnimate: false,
        fade: false,
        infinite: false,
        draggable: false,
        speed: 500
    };
    return /*#__PURE__*/ _jsx(StyledMobileCarouselTagsComponent, {
        children: /*#__PURE__*/ _jsx(CarouselTagsComponent, _object_spread_props(_object_spread({}, props), {
            tagsCarouselProps: tagsCarouselProps
        }))
    });
};
export default MobileCarouselTagsComponent;
